import React from 'react';

export const Spinner = ({ size = 24 }) => (
  <span
    className="spinner"
    style={{ width: size, height: size, borderWidth: Math.max(2, size / 8) }}
  />
);

export const LoadingState = ({ message = 'Loading...' }) => (
  <div className="loading-state">
    <Spinner size={36} />
    <p>{message}</p>
  </div>
);

export default LoadingState;
